var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('nav',[_c('div',{staticClass:"box"},[_c('div',{staticClass:"left"},[_c('p',[_vm._v("企业概况")]),_c('p',[_vm._v("企业文化")]),_c('p',[_vm._v("发展历程")]),_c('p',[_vm._v("荣誉奖项")])]),_c('div',{staticClass:"right"},[_c('p',[_vm._v("首页 "),_c('span',[_vm._v(">")])]),_c('p',[_vm._v("关于我们"),_c('span',[_vm._v(">")])]),_c('p',[_vm._v("企业概况")])])])])
}]

export { render, staticRenderFns }